import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';

const FAQ = () => {
  const faqs = [
    {
      question: 'How does the invite-only system work?',
      answer: 'Drivault is currently in invite-only mode to ensure the best experience for our users. You can request an invite through our waitlist, and existing users can send invites to friends and family.'
    },
    {
      question: 'How much free storage do I get?',
      answer: 'Every new user gets 100GB of free storage upon signup. You can earn up to 1TB additional free storage by inviting up to 9 friends who sign up and use Drivault.'
    },
    {
      question: 'What platforms are supported?',
      answer: 'Drivault works seamlessly across Windows, macOS, iOS, Android, and Linux. Your files stay in sync across all your devices automatically.'
    },
    {
      question: 'How secure is my data?',
      answer: 'We use 128-bit encryption for all data in transit and at rest. We also offer two-factor authentication, firewall protection, and secure backup to ensure your data is always protected.'
    },
    {
      question: 'What is the pricing for additional storage?',
      answer: 'Our pricing is simple: ₹0.5 per GB per month. You only pay for what you use, and you can always earn more free storage through our referral program.'
    },
    {
      question: 'Can I share files securely?',
      answer: 'Yes! You can share files via secure links with options for one-time access, repeated access, or password protection. You can also set custom expiration dates for your shared links.'
    }
  ];

  return (
    <section id="faq" className="py-20 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Frequently Asked <span className="text-[#40E095]">Questions</span>
          </h2>
          <p className="text-lg text-gray-600">
            Everything you need to know about Drivault
          </p>
        </div>

        {/* FAQ Accordion */}
        <div className="max-w-3xl mx-auto">
          <Accordion type="single" collapsible className="space-y-4">
            {faqs.map((faq, index) => (
              <AccordionItem 
                key={index} 
                value={`item-${index}`}
                className="border-2 border-gray-100 rounded-xl px-6 hover:border-[#40E095]/50 transition-all"
              >
                <AccordionTrigger className="text-left font-semibold text-gray-900 hover:text-[#40E095] py-6 hover:no-underline">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-gray-600 pb-6 leading-relaxed">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>

        {/* Additional Help */}
        <div className="text-center mt-12">
          <p className="text-gray-600">
            Still have questions?{' '}
            <a href="#waitlist" className="text-[#40E095] hover:underline font-semibold">
              Contact our support team
            </a>
          </p>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
